/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StatAggregateDataPoint } from './StatAggregateDataPoint';
import {
    StatAggregateDataPointFromJSON,
    StatAggregateDataPointFromJSONTyped,
    StatAggregateDataPointToJSON,
} from './StatAggregateDataPoint';

/**
 * 
 * @export
 * @interface StatsBillingGetResponse
 */
export interface StatsBillingGetResponse {
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsBillingGetResponse
     */
    billable_persons?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsBillingGetResponse
     */
    billable_persons_total?: number;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsBillingGetResponse
     */
    user_identities?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsBillingGetResponse
     */
    user_identities_total?: number;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsBillingGetResponse
     */
    non_human_identities?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsBillingGetResponse
     */
    non_human_identities_total?: number;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsBillingGetResponse
     */
    credentials?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsBillingGetResponse
     */
    credentials_total?: number;
}

/**
 * Check if a given object implements the StatsBillingGetResponse interface.
 */
export function instanceOfStatsBillingGetResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatsBillingGetResponseFromJSON(json: any): StatsBillingGetResponse {
    return StatsBillingGetResponseFromJSONTyped(json, false);
}

export function StatsBillingGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatsBillingGetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'billable_persons': !exists(json, 'billable_persons') ? undefined : ((json['billable_persons'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'billable_persons_total': !exists(json, 'billable_persons_total') ? undefined : json['billable_persons_total'],
        'user_identities': !exists(json, 'user_identities') ? undefined : ((json['user_identities'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'user_identities_total': !exists(json, 'user_identities_total') ? undefined : json['user_identities_total'],
        'non_human_identities': !exists(json, 'non_human_identities') ? undefined : ((json['non_human_identities'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'non_human_identities_total': !exists(json, 'non_human_identities_total') ? undefined : json['non_human_identities_total'],
        'credentials': !exists(json, 'credentials') ? undefined : ((json['credentials'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'credentials_total': !exists(json, 'credentials_total') ? undefined : json['credentials_total'],
    };
}

export function StatsBillingGetResponseToJSON(value?: StatsBillingGetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'billable_persons': value.billable_persons === undefined ? undefined : ((value.billable_persons as Array<any>).map(StatAggregateDataPointToJSON)),
        'billable_persons_total': value.billable_persons_total,
        'user_identities': value.user_identities === undefined ? undefined : ((value.user_identities as Array<any>).map(StatAggregateDataPointToJSON)),
        'user_identities_total': value.user_identities_total,
        'non_human_identities': value.non_human_identities === undefined ? undefined : ((value.non_human_identities as Array<any>).map(StatAggregateDataPointToJSON)),
        'non_human_identities_total': value.non_human_identities_total,
        'credentials': value.credentials === undefined ? undefined : ((value.credentials as Array<any>).map(StatAggregateDataPointToJSON)),
        'credentials_total': value.credentials_total,
    };
}

